import { render, staticRenderFns } from "./DeleteTweet.vue?vue&type=template&id=41f6c16c&scoped=true"
import script from "./DeleteTweet.vue?vue&type=script&lang=js"
export * from "./DeleteTweet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f6c16c",
  null
  
)

export default component.exports